import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';

export enum Roles {
  ADMIN = 'ADMIN',
  EXTERNAL_INSTALLER = 'EXTERNAL_INSTALLER',
  USER = 'USER',
}

export type ROLE = Roles;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly KEY_isAdmin: string = 'isAdmin';
  private readonly KEY_username: string = 'username';
  private readonly KEY_role: string = 'role';

  constructor(private localStorageService: LocalStorageService) {}

  public getIsAdmin() {
    return this.getRole() === Roles.ADMIN || this.localStorageService.get<Boolean>(this.KEY_isAdmin); // Backward compatibility
  }
  public setUsername(username: string) {
    this.localStorageService.save<string>(this.KEY_username, username);
  }
  public getUsername() {
    return this.localStorageService.get<string>(this.KEY_username);
  }
  public setRole(role: string) {
    this.localStorageService.save<string>(this.KEY_role, role);
  }
  public getRole(): ROLE | undefined {
    return this.localStorageService.get<ROLE>(this.KEY_role);
  }
  public hasRole(role: ROLE) {
    return this.hasOneOfRoles([role]);
  }
  public hasOneOfRoles(roles: ROLE[]) {
    const storedRole = this.getRole();

    // En prod, actuellement, les utilisateur sont loggé sans role stocké (legacy).
    // On considère donc que l'absence de role équivaut au role "USER"
    // À supprimer dès que tous les utilisateurs auront un role stocké.
    const role = storedRole === undefined ? Roles.USER : storedRole;
    return roles.includes(role);
  }
}
